<template>
  <span>
    {{ name }}
    <span v-if="currentUserName === name" class="body-md-bold">
      {{ this.$t("archives.ArchivesListArchiverName.archiverNameMatch") }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'ArchivesListArchiverName',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    currentUserName () {
      return this.$store.state.user.profile.fullName
    },
  },
}
</script>
